import { $apiPrivate } from "Api";

const WORK_PATH = "/works";
const CREATE_WORK_PATH = "/create";
const UPDATE_WORK_PATH = "/update";
const GET_ALL_WORK_PATH = "/all";
const GET_ALL_FOR_LIST_WORK_PATH = "/allforlist";

class WorkApi {
  getAllWorks = async (page = 1, searchValue, projectId = "", limit = 30) => {
    return await $apiPrivate.get(
      WORK_PATH +
        GET_ALL_WORK_PATH +
        `?page=${page}&search=${searchValue}&limit=${limit}&projectId=${projectId}`,
    );
  };
  getAllWorksForList = async (projectId = "") => {
    return await $apiPrivate.get(
      WORK_PATH + GET_ALL_FOR_LIST_WORK_PATH + `?projectId=${projectId}`,
    );
  };
  getSingleWork = async (workId) => {
    return await $apiPrivate.get(WORK_PATH + "/" + workId);
  };
  createWork = async (data) => {
    const { code, title, unit } = data;
    return await $apiPrivate.post(WORK_PATH + CREATE_WORK_PATH, {
      code,
      title,
      unit,
    });
  };
  updateWork = async (workData) => {
    return await $apiPrivate.post(WORK_PATH + UPDATE_WORK_PATH, {
      ...workData,
    });
  };
}

export default new WorkApi();
